import { render, staticRenderFns } from "./MainColumn.vue?vue&type=template&id=65efe133&scoped=true"
import script from "./MainColumn.vue?vue&type=script&lang=js"
export * from "./MainColumn.vue?vue&type=script&lang=js"
import style0 from "./MainColumn.vue?vue&type=style&index=0&id=65efe133&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65efe133",
  null
  
)

export default component.exports